export default "__VITE_ASSET__D1Y3C00g__"